import React, { useState } from 'react'

import { makeStyles, Typography, Box, Button } from '@material-ui/core'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import CheckIcon from '@material-ui/icons/Check'

import styles from './styles'

const useStyles = makeStyles(styles)

const NOTIFIED_MESSAGE =
  'Encontramos um erro inesperado e nossa equipe já foi notificada automaticamente. Você pode voltar ao início e tentar novamente. Se o problema continuar, entre em contato com o suporte informando o código abaixo.'

const NOT_NOTIFIED_MESSAGE =
  'Encontramos um erro inesperado. Você pode voltar ao início e tentar novamente. Se o problema continuar, entre em contato com o suporte para que possamos ajudar.'

const UnexpectedError = ({
  eventId,
  userId,
  companyId,
  previousPage,
  occurredAt: occurredAtProp,
}) => {
  const classes = useStyles()

  const [occurredAt] = useState(() => occurredAtProp || new Date())
  const [copied, setCopied] = useState(false)

  const getBrowserName = (userAgent) => {
    if (/edg/i.test(userAgent)) return 'Microsoft Edge'
    if (/opr|opera/i.test(userAgent)) return 'Opera'
    if (/chrome|chromium|crios/i.test(userAgent)) return 'Google Chrome'
    if (/firefox|fxios/i.test(userAgent)) return 'Mozilla Firefox'
    if (/safari/i.test(userAgent)) return 'Safari'
    return 'Navegador desconhecido'
  }

  const buildErrorReport = () => {
    const lines = ['Informações do erro']

    lines.push(`Data e hora: ${occurredAt.toLocaleString('pt-BR')}`)
    if (eventId) lines.push(`Código do erro: ${eventId}`)
    if (userId) lines.push(`ID do usuário: ${userId}`)
    if (companyId) lines.push(`ID da empresa: ${companyId}`)
    lines.push(`Navegador: ${window.navigator.userAgent}`)
    lines.push(`Página: ${window.location.href}`)
    if (previousPage) lines.push(`Página anterior: ${previousPage}`)

    return lines.join('\n')
  }

  const footerItems = [
    userId && { label: 'Usuário', value: userId },
    companyId && { label: 'Empresa', value: companyId },
    { label: 'Data', value: occurredAt.toLocaleString('pt-BR') },
    { label: 'Navegador', value: getBrowserName(window.navigator.userAgent) },
    previousPage && { label: 'Página anterior', value: previousPage },
  ].filter(Boolean)

  const handleCopy = async () => {
    try {
      await window.navigator.clipboard.writeText(buildErrorReport())
      setCopied(true)
      setTimeout(() => setCopied(false), 2500)
    } catch {
      // área de transferência indisponível — ignora silenciosamente
    }
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.content}>
        <Box className={classes.card}>
          <Box className={classes.badge}>
            <ErrorOutlineIcon className={classes.icon} />
          </Box>
          <Typography variant="h4" className={classes.title}>
            Ops! Algo deu errado
          </Typography>
          <Typography variant="body1" className={classes.subtitle}>
            {eventId ? NOTIFIED_MESSAGE : NOT_NOTIFIED_MESSAGE}
          </Typography>

          {eventId && (
            <Box className={classes.errorCodeBox}>
              <Typography variant="caption" className={classes.errorCodeLabel}>
                Código do erro
              </Typography>
              <Typography variant="body2" className={classes.errorCodeValue}>
                {eventId}
              </Typography>
            </Box>
          )}

          <Box className={classes.actions}>
            <Button
              className={classes.copyButton}
              color="primary"
              variant="outlined"
              startIcon={copied ? <CheckIcon /> : <FileCopyOutlinedIcon />}
              onClick={handleCopy}
            >
              {copied ? 'Copiado!' : 'Copiar informações'}
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => (window.location.href = '/')}
            >
              Voltar ao início
            </Button>
          </Box>
        </Box>
      </Box>

      <Box component="footer" className={classes.footer}>
        {footerItems.map((item) => (
          <Typography
            key={item.label}
            variant="caption"
            className={classes.footerItem}
          >
            <span className={classes.footerLabel}>{item.label}:</span>{' '}
            {item.value}
          </Typography>
        ))}
      </Box>
    </Box>
  )
}

export default UnexpectedError
